import { IconButton } from '@/components/ui/icon-button'
import { Text } from '@/components/ui/text'
import type { Tables } from '@hvf/contracts'
import { A } from '@solidjs/router'
import { Show } from 'solid-js'
import { css } from 'styled-system/css'
import { Box, Flex } from 'styled-system/jsx'

const BackArrowIcon = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    aria-hidden="true"
  >
    <path d="M19 12H5M11 18l-6-6 6-6" />
  </svg>
)

export default function AppBar(props: { setup: Tables<'setup'> }) {
  const isLong = () => props.setup.position === 'long'

  return (
    <Flex
      pos="sticky"
      top="0"
      zIndex="30"
      h="56px"
      alignItems="center"
      gap="8px"
      px="12px"
      flexShrink={0}
      style={{
        background: 'color-mix(in srgb, #fbfcfd 90%, transparent)',
        'backdrop-filter': 'blur(10px)',
        'border-bottom': '1px solid rgba(20, 22, 30, 0.09)',
      }}
    >
      <A href="/setups">
        <IconButton
          type="button"
          style={{
            background: '#ffffff',
            color: '#14161b',
            border: '1px solid rgba(20, 22, 30, 0.15)',
          }}
          class={css({
            w: '36px',
            h: '36px',
            minW: '36px',
            borderRadius: '10px',
            '& svg': { width: '18px', height: '18px' },
          })}
        >
          <BackArrowIcon />
        </IconButton>
      </A>

      <Flex
        flex="1"
        alignItems="center"
        justifyContent="center"
        gap="9px"
        minWidth={0}
      >
        <Text
          fontSize="23px"
          fontWeight="800"
          letterSpacing="-.02em"
          color="#14161b"
          whiteSpace="nowrap"
          truncate
        >
          {props.setup.symbol}
        </Text>
        <Text
          as="span"
          fontSize="14px"
          style={{ color: isLong() ? '#0a8f63' : '#e5604f' }}
        >
          {isLong() ? '▲' : '▼'}
        </Text>
        <Show when={props.setup.exchange}>
          <Text
            fontSize="11.5px"
            letterSpacing=".03em"
            fontWeight="600"
            color="#14161b"
            border="1px solid rgba(20, 22, 30, 0.15)"
            borderRadius="8px"
            px="9px"
            py="4px"
            whiteSpace="nowrap"
          >
            {props.setup.exchange}
          </Text>
        </Show>
      </Flex>

      <Box w="36px" h="36px" flexShrink={0} />
    </Flex>
  )
}
